/**
 * Generate a clean file name for an exported itinerary.
 *
 * @param {Object} tripData — trip document (needs title, startDate)
 * @param {'pdf' | 'docx'} format
 * @returns {string} e.g. "Australia-Itinerary-June-2026.pdf"
 */
export function generateExportFileName(tripData, format) {
  const title = (tripData.title || 'Trip')
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('-');

  let monthYear = '';
  if (tripData.startDate) {
    const date = new Date(tripData.startDate + 'T00:00:00');
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.getFullYear();
    monthYear = `-${month}-${year}`;
  }

  return `${title}-Itinerary${monthYear}.${format}`;
}
